if (!customElements.get('kw-footer-accordion')) {
  customElements.define('kw-footer-accordion', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.buttons = [...this.querySelectorAll('.kw-footer-toggle')];
      if (!this.buttons.length) return;
      this.media = window.matchMedia('(max-width: 749px)');
      this.onModeChange = () => {
        const mobile = this.media.matches;
        this.classList.toggle('is-mobile', mobile);
        this.buttons.forEach(button => {
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (!panel) return;
          button.disabled = !mobile;
          button.setAttribute('aria-expanded', String(!mobile));
          panel.hidden = mobile;
        });
      };
      this.onClick = event => {
        const button = event.target.closest('.kw-footer-toggle');
        if (!button || !this.contains(button) || !this.media.matches) return;
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        panel.hidden = !panel.hidden;
        button.setAttribute('aria-expanded', String(!panel.hidden));
      };
      this.addEventListener('click', this.onClick);
      this.media.addEventListener('change', this.onModeChange);
      this.initialized = true;
      this.onModeChange();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.media?.removeEventListener('change', this.onModeChange);
      this.initialized = false;
    }
  });
}
